import React from 'react'
import { ChartTable } from '../treasury-chart'

export default () => {
    return (<React.Fragment>
    {/* <div data-name="treasury-actions-charts" className="container vertical-offset-sm"> */}
        <ChartTable
            headerLabel="US yield curve"
            headerClassName="btn-label btn-flyout medium-header"
        />
    {/* </div> */}
    </React.Fragment>)
}
